import { Box } from "@mui/system"
import styled from "@emotion/styled";

const CompactFieldRowWrapperBox = styled(Box)(() => ({
    display: "flex",
    width: "100%",
    gap: "8px",
    margin: "8px"
  }));

const CompactFieldColumn = styled(Box)(() => ({
    display: "flex",
    width: "100%",
}));

export function CompactFieldRow(props:{
    firstchildren: JSX.Element
    secondchildren: JSX.Element
}){


    return(
        <>
        <CompactFieldRowWrapperBox>
            <CompactFieldColumn>{props.firstchildren}</CompactFieldColumn>
            <CompactFieldColumn>{props.secondchildren}</CompactFieldColumn>
        </CompactFieldRowWrapperBox>
        </>
    )
}

